module.exports = __webpack_public_path__ + "media/images/common/h3_sp-08615c969d25d2f1bbce488e5c00e11f.gif";